import { IContextMenuItem } from "Common/Interfaces";
import { CONTEXT_MENU_EVENTS } from "./ContextMenuEvents";
import { DeleteOutlined, EditChatOutlined } from "Icons/Icons";

export const CONTEXT_MENU_ITEMS: IContextMenuItem[] = [
  {
    event: CONTEXT_MENU_EVENTS.EDIT,
    icon: <EditChatOutlined />,
  },
  {
    event: CONTEXT_MENU_EVENTS.DELETE,
    icon: <DeleteOutlined />,
    hasDivider: true,
    errorColor: true,
  },
];
